import React from "react";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import CarePlanWidgetIcon from "../../../components/icon-components/CarePlanWidgetIcon";
import { useTranslation } from "react-i18next";

interface Props {
  description: string;
}

const CarePlanHeader: React.FC<Props> = ({ description }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack spacing={2}>
      <Box display="flex" alignItems="center" flexDirection="column" gap={2}>
        <CarePlanWidgetIcon
          width={isMobile ? 64 : 88}
          height={isMobile ? 68 : 94}
        />
        <Typography
          variant="bodySmall"
          fontWeight={700}
          textTransform="uppercase"
          color="common.black"
          letterSpacing={1}
        >
          {t("carePlan.whatToExpect")}
        </Typography>
        <Typography variant="body1" mx={{ xs: 4, md: 8 }} textAlign="center">
          {description}
        </Typography>
      </Box>
    </Stack>
  );
};
export default CarePlanHeader;
